import { CheckCircle } from "lucide-react";
import { GetList } from "types/data-content";

interface IServicePage {
  pageData: GetList;
}

const BenefitsSection = ({ pageData }: IServicePage) => {
  return (
    <section className="py-8 sm:py-16 px-6 bg-background mb-8 sm:mb-16 bg-gray-200">
      <div className="container mx-auto px-4 sm:max-w-4xl">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 text-foreground">
          {pageData.benefitsTitle}
        </h2>
        <div className="grid md:grid-cols-2 gap-2">
          {pageData?.includedFeatures?.map((benefit, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-4 rounded-lg hover:bg-muted/50 transition-colors"
            >
              <CheckCircle className="h-6 w-6 text-primary flex-shrink-0 mt-0.5" />
              <span className="text-lg text-foreground">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
